import { Box, TablePagination } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Pagination } from '~/components/data-grid';
import { usePaginationParams } from '~/hooks/pagination';

export interface ContentPaginationProps {
  totalCount: number;
}

export const ContentPagination = ({ totalCount }: ContentPaginationProps) => {
  const { t } = useTranslation();
  const { page, perPage, setPageParams } = usePaginationParams();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <TablePagination
        ActionsComponent={Pagination}
        count={totalCount}
        labelRowsPerPage={t('common.pagination.per_page')}
        labelDisplayedRows={({ from, to, count }) =>
          t('common.pagination.displayed_rows', { from, to, count })
        }
        onPageChange={(_, newPage) => setPageParams({ page: newPage + 1, perPage })}
        onRowsPerPageChange={(event) =>
          setPageParams({ page: 1, perPage: parseInt(event.target.value) })
        }
        page={page - 1}
        rowsPerPage={perPage}
        rowsPerPageOptions={[25, 50, 100]}
      />
    </Box>
  );
};
